<template>
  <div class="article-slideout" :class="{ 'is-active': data }">
    <a v-on:click="closeArticleSlideout" class="btn-close" title="Close"></a>
    <div class="content">
      <p v-if="!data && !errorLoading">Loading...</p>
      <p v-if="errorLoading">Unable to retrieve article information</p>
      <div v-if="data">
        <h3>{{ data.name }}</h3>
        <p>
        Raw Material: {{ data.rawMaterial }}
        <br />
        Average Hide Size: <span v-for="(hideSize, index) in data.averageHideSize">{{ hideSize.name }}<span v-if="index != (data.averageHideSize.length - 1)">,</span>
        </p>
        <div v-html="data.content"></div>
        <p><img :src="data.thumbnail" /></p>
        <p class="btn-wrap"><a href="#view-swatches" title="View Swatches" @click.prevent="viewSwatches">View Swatches</a></p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ArticleSlideout',
    props: {
      slideoutArticleId: Number,
      articles: Object,
    },
    computed: {
      data() {
        return this.articles[`id${this.slideoutArticleId}`]
      },
    },
    methods: {
      closeArticleSlideout() {
        this.$emit('close')
      },
      viewSwatches() {
        this.closeArticleSlideout()
        this.$parent.$emit('view-swatches', this.slideoutArticleId)
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/ArticleSlideout.vue